import img1 from "src/assets/images/home/services/1.webp";
import img2 from "src/assets/images/home/services/2.webp";
import img3 from "src/assets/images/home/services/3.webp";
import img4 from "src/assets/images/home/services/4.webp";
import img5 from "src/assets/images/home/services/5.webp";
import img6 from "src/assets/images/home/services/6.webp";



export type ServiceType = {
    title: {
        [key: string]: string
    };
    text: {
        [key: string]: string
    };
    path?: string,
    img: any;
}

export const servicesData: ServiceType[] = [
    {
        title: {
            ar: "قص الرخام والجرانيت",
            en: "Marble & Granite Cutting"
        },
        text: {
            en: "Precision cutting using state-of-the-art technology to ensure unmatched quality for every slab.",
            ar: "قص دقيق باستخدام أحدث التقنيات لضمان جودة لا تضاهى لكل قطعة رخام أو جرانيت."
        },
        path: "/services/cutting",
        img: img1
    },
    {
        title: {
            ar: "أسطح المطابخ",
            en: "Premium Countertops"
        },
        text: {
            en: "Transform your kitchen with stunning, durable marble and granite countertops tailored to your space.",
            ar: "زين مطبخك بأسطح رخام وجرانيت مذهلة ومتينة مصممة خصيصًا لتناسب مساحتك."
        },
        path: "/services/countertops",
        img: img2
    },
    {
        title: {
            ar: "تركيب الأرضيات",
            en: "Elegant Flooring"
        },
        text: {
            en: "Expert installation of marble flooring that brings timeless beauty and luxury to your home.",
            ar: "تركيب احترافي للأرضيات الرخامية التي تضفي جمالاً خلابا وفخامة على منزلك."
        },
        path: "/services/flooring",
        img: img3
    },
    {
        title: {
            ar: "تصاميم مخصصة",
            en: "Custom-made Tiles"
        },
        text: {
            en: "Wide range of styles and finishes for custom-made tiles to suit your unique taste.",
            ar: "مجموعة واسعة من الأنماط والتشطيبات للبلاط المصنوع حسب الطلب ليناسب ذوقك الفريد."
        },
        path: "/services/custom-tiles",
        img: img4
    },
    {
        title: {
            ar: "التشطيبات الفاخرة",
            en: "Exquisite Finishing"
        },
        text: {
            en: "Our skilled artisans ensure professional finishing for a smooth and sophisticated look.",
            ar: "يضمن حرفيونا المهرة تشطيبات احترافية للحصول على مظهر ناعم وراقي."
        },
        path: "/services/finishing",
        img: img5
    },
    {
        title: {
            ar: "تجهيز الواجهات",
            en: "Wall Cladding & Facades"
        },
        text: {
            en: "Add a touch of elegance to your interior spaces with our exquisite marble and granite cladding designs.",
            ar: "أضف لمسة من الفخامة على مساحاتك الداخلية من خلال تشكيلاتنا الراقية من الرخام والجرانيت التي تجمع بين الفن والدقة."
        },
        path: "/services/cladding",
        img: img6
    }
];